module.exports = __webpack_public_path__ + "img/clock.237cb59b.png";